import React from 'react';
import Image2 from '../../images/300x169.jpg';
import { getSlug } from '../../utils/helper';

const SEO = ({ seoProps, isCampagin }) => {
  const {
    title,
    description,
    image,
    pageUrl,
    prevPage,
    nextPage,
    canonicalUrl,
    slug,
  } = seoProps;

  const updatedPageUrl =
    slug === '/events/past-events/' ? `${pageUrl}past-events/` : pageUrl;
  const defaultUrl = slug
    ? `${process.env.GATSBY_SITE_URL}${slug}`
    : `${process.env.GATSBY_SITE_URL}/`;
  const canonical = canonicalUrl
    ? `${process.env.GATSBY_SITE_URL}${getSlug(canonicalUrl)}`
    : defaultUrl;

  return (
    <>
      <meta
        name='google-site-verification'
        content='uSqrYjmoMx2_5aVifkVqu3D5vaG8TDPvSzq_saIo_aM'
      />
      <meta httpEquiv='cache-control' content='max-age=0' />
      <meta httpEquiv='cache-control' content='no-cache' />
      <meta httpEquiv='expires' content='0' />
      <meta httpEquiv='pragma' content='no-cache' />
      <meta name='keywords' content={description} />

      {/* -----Primary Meta Tags------ */}
      <title>{title}</title>
      <meta name='title' content={title} />
      <meta name='description' content={description} />

      {/* -----Open Graph / Facebook----- */}
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content={
          updatedPageUrl !== undefined
            ? `${updatedPageUrl}`
            : 'https://www.pandemicactionnetwork.org/'
        }
      />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={image || Image2} />

      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />

      {/* -----Twitter----- */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta
        name='twitter:url'
        content={
          updatedPageUrl !== undefined
            ? `${updatedPageUrl}`
            : 'https://www.pandemicactionnetwork.org/'
        }
      />
      <meta name='twitter:site' content='@PandemicAction' />
      <meta name='twitter:creator' content='@PandemicAction' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />

      {/* -----Pagination attributes----- */}
      {/* If previous page is present add noindex,nofollow  */}
      {prevPage && <meta name='robots' content='noindex,nofollow' />}
      {prevPage && <link rel='prev' href={prevPage} />}
      {nextPage && <link rel='next' href={nextPage} />}

      <meta
        name='twitter:image'
        content={
          image ? `${image}?t=${Math.random().toString(16).slice(2)}` : Image2
        }
      />
      <script type='text/javascript'>
        {`
          (function(c,l,a,r,i,t,y){
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "hj4wr8bd06");
          `}
      </script>
      {isCampagin ? (
        <script type='text/javascript' defer>
          {`!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
            },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
            a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
            twq('init','o92a0');
            twq('track','PageView');`}
        </script>
      ) : null}
      <script type='application/ld+json'>
        {`
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "@id": "https://pandemicactionnetwork.org/#website",
                "url": "https://pandemicactionnetwork.org/",
                "name": "Pandemic Action Network",
                "description": "United action now to respond to COVID-19 and prepare for future pandemics",
                "potentialAction": [
                  {
                    "@type": "SearchAction",
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "https://pandemicactionnetwork.org/?s={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                  }
                ],
                "inLanguage": "en-US"
              }
            `}
      </script>
      {canonical && <link rel='canonical' href={canonical} />}
    </>
  );
};

export default SEO;
